/**
 * Shared type colors for database column type chips.
 *
 * Used by:
 * - database-canvas-block.ts (Lit)
 * - automation-canvas-block.ts (Lit)
 * - type-chip.tsx (React)
 */

// Type colors - grouped by castability (castable types share colors)
export const TYPE_COLORS: Record<string, string> = {
  // Text-like (all castable to each other)
  string: '#10b981', // emerald-500
  text: '#10b981',
  title: '#10b981',
  'rich-text': '#10b981',

  // Number-like (castable)
  number: '#3b82f6', // blue-500
  progress: '#3b82f6',

  // Boolean-like (castable)
  boolean: '#b45309', // amber-700
  checkbox: '#b45309',

  // Array-like (castable)
  array: '#8b5cf6', // violet-500
  'multi-select': '#8b5cf6',

  // Select
  select: '#ec4899', // pink-500

  // Date
  date: '#06b6d4', // cyan-500

  // File-like (castable)
  attachment: '#f97316', // orange-500
  file: '#f97316',
  image: '#f97316',

  // Generic object
  object: '#6b7280', // gray-500
};

/**
 * Normalize type label for display
 */
export function normalizeTypeLabel(type: string): string {
  const normalized = type.toLowerCase().replace(/\[\d+\]/g, '');
  // User-friendly: "string" → "text" (non-technical users don't know "string")
  if (normalized === 'string') return 'text';
  return normalized;
}

/**
 * Get color for a type string
 */
export function getTypeColor(type: string): string {
  const normalized = normalizeTypeLabel(type);

  // Direct match
  if (TYPE_COLORS[normalized]) {
    return TYPE_COLORS[normalized];
  }

  // Partial match
  for (const [key, color] of Object.entries(TYPE_COLORS)) {
    if (normalized.includes(key)) {
      return color;
    }
  }

  return '#6b7280'; // gray-500 default
}
